import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormLabel,
  Modal,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import {
  ModalActionButtonStyles,
  ModalBaseStyles,
  ModalHeader,
} from "../Common/styles/modal";
import { Formik } from "formik";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import * as yup from "yup";
import { AxiosResponse } from "axios";
import http from "../../utils/http";

type Props = {
  data?: any;
  open: boolean;
  closeModal: () => void;
  refreshPage: () => void;
};

let schema = yup.object().shape({
  name: yup.string().required("Tag Name is Required"),
});

const CreateTagModal = ({ data, open, closeModal, refreshPage }: Props) => {
  const [submitLoader, setSubmitLoader] = useState(false);

  const submitHandler = async (values: any) => {
    try {
      setSubmitLoader(true);
      let res: AxiosResponse;
      if (data?.id) {
        res = await http.patch(`/platform-tags/${data?.id}`, {
          ...values,
          status: data?.status,
        });
      } else {
        res = await http.post(`/platform-tags`, {
          ...values,
          status: "active",
        });
      }
      toastMessage("success", res.data.message);
      closeModal();
      refreshPage();
    } catch (error) {
      errorToastMessage(error as Error);
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "10vh" }}>
        <ModalHeader
          title={data?.id ? "Edit Tag" : "Add Tag"}
          onCloseClick={closeModal}
        />
        <Formik
          initialValues={{
            name: data?.name || "",
          }}
          validationSchema={schema}
          onSubmit={(values) => {
            submitHandler(values);
          }}
        >
          {({
            handleSubmit,
            getFieldProps,
            // setFieldValue,
            // values,
            errors,
            touched,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <FormControl sx={InputWrapper}>
                  <FormLabel sx={LabelStyle} htmlFor="tag-name">
                    Tag Name <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <TextField
                    fullWidth
                    id="tag-name"
                    {...getFieldProps("name")}
                    error={touched?.name && errors?.name ? true : false}
                    helperText={
                      touched?.name && errors?.name
                        ? (errors?.name as string)
                        : " "
                    }
                    placeholder="Tag Name"
                  />
                </FormControl>
              </Box>
              <Box sx={ModalActionButtonStyles}>
                {!submitLoader ? (
                  <>
                    <Button onClick={closeModal} variant="outlined">
                      Cancel
                    </Button>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </>
                ) : (
                  <CircularProgress size={25} />
                )}
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default CreateTagModal;
